"use strict";
/**
 * Sizing guide click to enlarge image func
 *
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Alexandra Miro
 */
Object.defineProperty(exports, "__esModule", { value: true });
var sizingGuideEnlarge = function () {
    var sizingGuide = document.querySelector(".sizingGuide");
    if (!sizingGuide)
        return;
    var sizingGuideBackdrop = document.querySelector(".sizingGuideBackdrop");
    var sizingGuideImage = sizingGuide.querySelector("img");
    var sizingGuideImageClone = sizingGuideImage === null || sizingGuideImage === void 0 ? void 0 : sizingGuideImage.cloneNode(true);
    if (sizingGuideImageClone && sizingGuideImage) {
        sizingGuideBackdrop === null || sizingGuideBackdrop === void 0 ? void 0 : sizingGuideBackdrop.appendChild(sizingGuideImageClone);
    }
    var showSizingGuide = function () {
        sizingGuideBackdrop === null || sizingGuideBackdrop === void 0 ? void 0 : sizingGuideBackdrop.classList.add("toggled");
    };
    var handleHideSizingGuide = function () {
        sizingGuideBackdrop === null || sizingGuideBackdrop === void 0 ? void 0 : sizingGuideBackdrop.classList.remove("toggled");
    };
    sizingGuideImage === null || sizingGuideImage === void 0 ? void 0 : sizingGuideImage.addEventListener("click", function () {
        if (sizingGuideImage.classList.contains("toggled")) {
            handleHideSizingGuide();
        }
        else {
            showSizingGuide();
        }
    });
    sizingGuideBackdrop === null || sizingGuideBackdrop === void 0 ? void 0 : sizingGuideBackdrop.addEventListener("click", function () {
        handleHideSizingGuide();
    });
};
exports.default = sizingGuideEnlarge;
